export default __webpack_public_path__ + "static/media/1917.05d15077.png";